export default __webpack_public_path__ + "static/media/MBS.0fab1ba5.pdf";